import { TextField } from "@mui/material";
import { t } from "i18next";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";

const DetailTask = ({
  task,
  editTask = false,
  onInputChange,
  onClose,
  onSave,
  onEdit,
  onLoading,
}) => {
  return (
    <div className="flex flex-col gap-4">
      <h3>{editTask ? t("EditTask") : t("AddTask")}</h3>
      <TextField
        label={t("Name")}
        value={task.name}
        onChange={(e) => onInputChange("name", e.target.value)}
        fullWidth
        required
      />
      <TextField
        label={t("Description")}
        value={task.description}
        onChange={(e) => onInputChange("description", e.target.value)}
        fullWidth
        multiline
        rows={3}
        required
      />
      <TextField
        label={t("Note")}
        value={task.notes}
        onChange={(e) => onInputChange("notes", e.target.value)}
        fullWidth
        multiline
        rows={2}
      />
      <div className="flex justify-around gap-2">
        <TextField
          label={t("StartDate")}
          type="date"
          value={task.startingDate}
          onChange={(e) => onInputChange("startingDate", e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
        <TextField
          label={t("EndDate")}
          type="date"
          value={task.endDate}
          onChange={(e) => onInputChange("endDate", e.target.value)}
          InputLabelProps={{ shrink: true }}
          fullWidth
        />
      </div>
      <TextField
        label={t("EstimatedEffort")}
        type="number"
        value={task.estimatedEffort}
        onChange={(e) =>
          onInputChange("estimatedEffort", parseFloat(e.target.value) || 0)
        }
        fullWidth
        InputProps={{ endAdornment: "h" }}
      />
      <div className="flex justify-around mt-4 py-8">
        <CoreButton
          className="btn-round-outline"
          testo={t("Cancel")}
          onClick={onClose}
        />
        <CoreButton
          onClick={editTask ? onEdit : onSave}
          className="bg-primary btn-round border-primary"
          disabled={!task.name || !task.description || onLoading}
          testo={t("Save")}
        />
      </div>
    </div>
  );
};

export default DetailTask;
